export interface User {
  id: number;
  name: string;
  age: number;
  photo: string;
  description: string;
}

export const users: User[] = [
  {
    id: 1,
    name: 'Елизавета',
    age: 23,
    photo:
      'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=600&fit=crop&crop=face',
    description:
      'Люблю готовить, кататься на борде и путешествовать, за новые знакомства. Не стесняйся, пиши первым ;)',
  },
  {
    id: 2,
    name: 'Анна',
    age: 25,
    photo:
      'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=600&fit=crop&crop=face',
    description:
      'Занимаюсь спортом, читаю книги и работаю в IT. Ищу интересные знакомства и новые впечатления!',
  },
  {
    id: 3,
    name: 'Мария',
    age: 22,
    photo:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=600&fit=crop&crop=face',
    description:
      'Художница и любительница кофе. Обожаю музеи, выставки и долгие прогулки по городу.',
  },
  {
    id: 4,
    name: 'София',
    age: 26,
    photo:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=600&fit=crop&crop=face',
    description:
      'Учитель английского языка, люблю танцы и театр. В свободное время изучаю новые языки.',
  },
  {
    id: 5,
    name: 'Екатерина',
    age: 24,
    photo:
      'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=600&fit=crop&crop=face',
    description:
      'Фотограф-фрилансер, путешествую по миру и снимаю людей. Всегда открыта новым знакомствам!',
  },
  {
    id: 6,
    name: 'Дарья',
    age: 21,
    photo:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=600&fit=crop&crop=face',
    description:
      'Студентка медицинского университета. Увлекаюсь психологией, йогой и здоровым образом жизни.',
  },
  {
    id: 7,
    name: 'Валерия',
    age: 27,
    photo:
      'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=600&fit=crop&crop=face',
    description:
      'Маркетолог в крупной компании. Люблю активный отдых, велосипедные прогулки и хорошие фильмы.',
  },
];
